import tns from '@/lib/tiny-slider/tiny-slider.js';

var tcCarousel;

document.addEventListener(
    "DOMContentLoaded", () => {
        var urlParams = new URLSearchParams(window.location.search);
        var roomId = urlParams.get('roomId');

        if (roomId) {
            getRoomDetails(roomId);

            document.querySelector(".room-list-link.selected").classList.remove('selected');
            document.querySelector(".room-list-link[data-room-id='" + roomId + "']").classList.add("selected");

            var scrollElement = document.getElementById("room-list-ctrl");
            scrollElement.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
            createCarousel();
        }
    }
);

const roomLinks = document.querySelectorAll('.room-list-link');
roomLinks.forEach(el => el.addEventListener('click', event => {
    event.preventDefault();

    var roomId = el.dataset.roomId;

    getRoomDetails(roomId);

    document.querySelector(".room-list-link.selected").classList.remove('selected');

    el.classList.add('selected');
}));

async function getRoomDetails(roomId) {
    try {
        const response = await fetch('/umbraco/surface/RoomsSurface/GetRoomDetails?roomId=' + roomId);
        const body = await response.text();

        document.querySelector('.room-item-wrapper').innerHTML = body;

        createCarousel();
    } catch (error) {
        console.log(error);
    }
}

function createCarousel() {
    tcCarousel = tns({
        container: '.control-room-list .room-gallery',
        items: 1,
        slideBy: 1,
        autoplay: false,
        controls: true,
        controlsPosition: true,
        nav: false,
        speed: 800,
        controlsContainer: document.querySelector('.control-room-list .tns-controls')
    });
}
